import { ReactElement } from 'react';

import { useConnection } from 'modules/auth/hooks/useConnection';
import { DECIMAL_PLACES_SHORT, ZERO } from 'modules/common/const';
import { useGlobalTranslation } from 'modules/i18n';
import { useGetLiquidStakingTokenQuery } from 'modules/liquidStaking/actions/getLiquidStakingToken';
import { useGetLiquidStakingAPY } from 'modules/liquidStaking/hooks/useGetLiquidStakingAPY';
import { useLiquidStakingPool } from 'modules/liquidStaking/hooks/useLiquidStakingPool';
import { LiquidStakingRoutesConfig } from 'modules/liquidStaking/Routes';

import { StakingSectionFooter } from '../StakingSection';
import { StakingStats, StakingStatsItem } from '../StakingStats';
import { translation } from './translation';

export function LiquidStakingEmpty(): ReactElement | null {
  const { keys, t } = useGlobalTranslation(translation);
  const { apy, isLoading: isAPYLoading } = useGetLiquidStakingAPY();
  const { cacheTime } = useConnection();
  const { data, isLoading: isDataLoading } = useGetLiquidStakingTokenQuery(
    undefined,
    {
      refetchOnMountOrArgChange: cacheTime,
    },
  );

  const isStatsLoading = isAPYLoading || isDataLoading;
  const totalAmount = data?.totalAmount || ZERO;

  const { isDeprecated } = useLiquidStakingPool();
  if (isDeprecated) {
    return null;
  }

  return (
    <StakingSectionFooter
      stakingLink={LiquidStakingRoutesConfig.dashboard.generatePath()}
    >
      <StakingStats>
        <StakingStatsItem
          isLoading={isStatsLoading}
          title={t(keys.apy)}
          value={t(keys.unit.percent, {
            value: apy.decimalPlaces(DECIMAL_PLACES_SHORT).toFormat(),
          })}
        />

        <StakingStatsItem
          isLoading={isStatsLoading}
          title={t(keys.tvl)}
          value={t(keys.number.compact, {
            value: totalAmount.decimalPlaces(DECIMAL_PLACES_SHORT).toNumber(),
          })}
        />

        <StakingStatsItem
          isLoading={isStatsLoading}
          title={t(keys.opportunities)}
          value={t(keys.deFi)}
        />
      </StakingStats>
    </StakingSectionFooter>
  );
}
